const dogCareService = {
  title: "Dog Walker / Sitter",
  icon: "🐶",
  rateCardKey: "dog-care",
  shortDescription:
    "Dog walking, short sitting visits, feeding support, and basic pet care assistance.",
  longDescription:
    "Book pet support for dog walking, short sitting sessions, feeding help, and basic at-home care assistance.",
  consultationNote:
    "Special medical care, overnight boarding, or aggressive pet handling should require clear confirmation first.",
  responsePromise:
    "Assignment depends on location, time slot, pet size, and sitter comfort level.",
  warrantyPolicy:
    "Pet behavior and comfort depend on routine familiarity, pet temperament, and owner instructions.",
  subServices: [
    {
      id: "dog-walk-30",
      title: "Dog Walk - 30 Minutes",
      icon: "🚶",
      group: "Walking",
      description:
        "Standard dog walking support for one short routine outing.",
      basePrice: 199,
      priceType: "fixed",
      duration: "30 mins",
      warranty: "Visit completion only",
      unit: "walk",
    },
    {
      id: "dog-walk-60",
      title: "Dog Walk - 60 Minutes",
      icon: "🐕",
      group: "Walking",
      description:
        "Extended walking session for active pets needing longer outdoor time.",
      basePrice: 349,
      priceType: "fixed",
      duration: "60 mins",
      warranty: "Visit completion only",
      unit: "walk",
    },
    {
      id: "dog-sit-visit",
      title: "Dog Sitting Visit",
      icon: "🏠",
      group: "Sitting",
      description:
        "Short home visit for feeding, pet check, and basic care support.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "45-90 mins",
      warranty: "Visit completion only",
      unit: "visit",
    },
    {
      id: "dog-care-plan-consult",
      title: "Pet Care Consultation",
      icon: "📋",
      group: "Consultation",
      description:
        "Consultation for recurring pet support, walker planning, or sitter schedule.",
      basePrice: 199,
      priceType: "inspection",
      duration: "20-30 mins",
      warranty: "Consultation only",
      unit: "consult",
    },
  ],
};

export default dogCareService;